<template>
  <form @submit.prevent='submit'
        class="d-flex align-items-center mb-2">
    <div class="field has-addons w-100p">
      <div class="control is-medium grow-1" :class="loading && 'is-loading'">
        <input
          class="input is-medium"
          v-model="proxyValue"
          autocomplete="false"
          id="search-box"
          autofocus
          placeholder="Type a name" />
      </div>
      <div class="control is-medium">
        <button class="button is-primary is-medium"
            :class="loading && 'is-loading'"
            type="submit">
            Search
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: 'SearchBox',
  data () {
    return {
      loading: false,
    }
  },
  props: {
    search: {
      type: Function,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Make a search.'
    },
    value: {
      type: String,
      default: '',
    },
  },
  methods: {
    submit () {
      this.loading = true
      this.search(this.proxyValue)
      .then(() => {
        this.loading = false
      })
    },
  },
  mounted () {
    document.getElementById('search-box').focus()
  },
  computed: {
    proxyValue: {
      get () {
        return this.value
      },
      set (newVal) {
        this.$emit('update:value', newVal)
      },
    },
  },
}
</script>



// WEBPACK FOOTER //
// SearchBox.vue?cfde9c12